module.exports = __webpack_public_path__ + "static/media/laundry_carousel.469f60a9.jpg";